import { defineVariants } from '@/runtime/style-engine/define-variants';

/**
 * Tailwind-like class variants for `<e-editor>`.
 *
 * Used to style the outer editor container (not Monaco itself).
 */
export const editorStyles = defineVariants({
  base: `
    block w-full h-full
    min-h-[100px]
    overflow-hidden
    rounded-xl
    bg-[var(--editor-bg,#1e1e1e)]
  `,

  variants: {
    /**
     * Visual theme of the editor container.
     */
    theme: {
      light: 'bg-[var(--editor-bg-light,#ffffff)]',
      dark: 'bg-[var(--editor-bg-dark,#1e1e1e)]'
    }
  },

  defaults: {
    theme: 'dark'
  }
});
